module.exports = __webpack_public_path__ + "img/ico-estoque.427fee62.png";